import { jsx as _jsx } from "nativewind/jsx-runtime";
import React, { forwardRef } from 'react';
import { View } from 'react-native';
import { match, Pattern } from 'ts-pattern';
import SignupBoxInput from '@/screens/SignupScreen/components/SignupBoxInput';
const UserBirthYearForm = forwardRef(({ value, state, onChangeText, onSubmitEditing }, _ref) => {
    return (_jsx(View, { style: { paddingHorizontal: 20 }, children: _jsx(SignupBoxInput, { label: "\uCD9C\uC0DD\uB144\uB3C4", isRequired: true, placeholder: "\uCD9C\uC0DD\uB144\uB3C4\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694", keyboardType: "number-pad", maxLength: 4, state: state, caption: match(state)
                .with({ errorMessage: Pattern.string }, error => error.errorMessage)
                .otherwise(() => undefined), value: value, onChangeText: text => {
                const numbersOnly = text.replace(/[^0-9]/g, '');
                onChangeText(numbersOnly);
            }, onSubmitEditing: onSubmitEditing }) }));
});
UserBirthYearForm.displayName = 'UserBirthYearForm';
export default UserBirthYearForm;
